import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

/**
 * Reusable international phone input for every OrangeBySite form.
 * Wraps `react-phone-number-input` (searchable country list + flags + E.164 storage).
 *
 * Props:
 *  - value: E.164 string (e.g. "+971585607119")
 *  - onChange: (value: string | undefined) => void
 *  - defaultCountry: ISO 2-letter code (default "GB")
 *  - id, name, testid, placeholder, invalid (boolean), ariaDescribedBy
 */
export default function InternationalPhoneInput({
  id,
  name = "phone",
  value,
  onChange,
  defaultCountry = "GB",
  placeholder = "7700 000000",
  invalid = false,
  testid = "intl-phone",
  ariaDescribedBy,
}) {
  return (
    <div
      className={`obs-intl-phone rounded-xl bg-white/80 border transition-colors ${
        invalid
          ? "border-[#C1350B] focus-within:border-[#C1350B]"
          : "border-black/15 focus-within:border-black"
      }`}
      data-testid={testid}
    >
      <PhoneInput
        id={id}
        name={name}
        value={value || ""}
        onChange={onChange}
        defaultCountry={defaultCountry}
        international
        countryCallingCodeEditable={false}
        addInternationalOption={false}
        placeholder={placeholder}
        smartCaret
        aria-invalid={invalid}
        aria-describedby={ariaDescribedBy}
        numberInputProps={{
          className:
            "flex-1 h-12 bg-transparent px-3 text-black placeholder:text-black/40 focus:outline-none font-medium text-[15px]",
          "data-testid": `${testid}-number`,
          autoComplete: "tel-national",
          inputMode: "tel",
        }}
      />
    </div>
  );
}
